import { PropsWithChildren } from 'react';
import cx from 'classnames';

interface FormProps {
  onSubmit: () => void;
  className?: string;
}

export const Form: React.FC<PropsWithChildren<FormProps>> = ({
  onSubmit,
  className,
  children,
}) => (
  <form
    className={cx('p-4 md:p-6 space-y-4', className)}
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
  >
    {children}
  </form>
);

export const FormSection: React.FC<PropsWithChildren> = ({ children }) => (
  <div className="space-y-4">{children}</div>
);

export const FormRow: React.FC<PropsWithChildren> = ({ children }) => (
  <div className="w-full flex flex-col md:flex-row space-x-4">{children}</div>
);

interface FormFieldProps {
  labelText?: string;
  error?: string;
  className?: string;
  optional?: boolean;
}

export const FormField: React.FC<PropsWithChildren<FormFieldProps>> = ({
  labelText,
  error,
  className,
  optional = false,
  children,
}) => (
  <div className={cx('w-full md:w-1/2 mb-2 sm:mb-4 md:mb-0', className)}>
    <label>
      {(labelText || optional) && (
        <div className="text-sm text-gray-700 mb-1" aria-label={labelText}>
          {/* Empty non-breaking space for vertical alignments */}
          {labelText || String.fromCharCode(160)}
          {optional && (
            <>
              {' '}
              <span className="text-xs text-gray-500">(optional)</span>
            </>
          )}
        </div>
      )}
      <div className="flex space-x-2">{children}</div>
    </label>
    {!!error && (
      <span className="block text-red-600 text-xs mt-1 mb-1">{error}</span>
    )}
  </div>
);
